import { createContext, useContext } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ session, signOut, children }) {
  return (
    <AuthContext.Provider value={{ session, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
